import React, { Fragment, useEffect, useState, useCallback, useRef } from "react";
import { Table } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';
import { getOwnLeaveCalenderListData, AddReportPersonalDetailsData, AddAppliedLeaveData, getOwnReportLeaveListData } from '../../../store/actions/LeaveAction';

const LeaveCardView = ({ userId, filterType, startDate, endDate, isAddLeave, grandHour, generateReport, changeReport, isEditLeave = false }) => {
    const dispatch = useDispatch();
    const leaveStartDateRef = useRef();
    // const calendarLeave = useSelector((state) => state.leave.calendarLeave);
    const leaveReport = useSelector((state) => state.leave.leaveReport);
    const leaveType = useSelector((state) => state.leave.leaveType);
    const [type, setType] = useState('');
    const [isLeave, setIsLeave] = useState(false);
    const [isCollapse, setIsCollapse] = useState(isAddLeave ?? false);
    const [isIndex, setIsIndex] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [list, setList] = useState([]);
    const [personalDetails, setPersonalDetails] = useState(null);


    let errorsLeaveObj = { type: '', startDate: '', hours: '' };
    const [leaveErrors, setLeaveErrors] = useState(errorsLeaveObj);
    const [leaveDescription, setLeaveDescription] = useState('');
    const [leaveStartDate, setLeaveStartDate] = useState(null);
    const [leaveTypes, setLeaveTypes] = useState('');
    const [total, setTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);

    useEffect(() => {
        // console.log('leaveReport..', leaveReport.data)
        setPersonalDetails(leaveReport);
        setList(leaveReport?.data ?? []);
        setTotal(leaveReport?.total_hour)
        const totalHour = parseFloat(leaveReport?.total_hour);
        const grand = parseFloat(grandHour);

        if (!isNaN(totalHour) && !isNaN(grand)) {
            setGrandTotal(totalHour + grand);
        } else {
            setGrandTotal(0);
        }
    }, [leaveReport, grandHour]);



    const getDateRange = useCallback(() => {
        if (filterType === 2) {
            return {
                start: moment().startOf('week').format('YYYY-MM-DD'),
                end: moment().endOf('week').format('YYYY-MM-DD'),
            };
        } else if (filterType === 3 && startDate && endDate) {
            return {
                start: moment(startDate).format('YYYY-MM-DD'),
                end: moment(endDate).format('YYYY-MM-DD'),
            };
        }
        return null;
    }, [filterType, startDate, endDate]);

    useEffect(() => {
        if (!userId || !filterType) return;
        const dateRange = getDateRange();
        if (!dateRange) return;
        setType('');
        dispatch(getOwnReportLeaveListData(userId, filterType, dateRange.start, dateRange.end, ''));
        closeLeave();
        setIsLeave(false);
    }, [userId, filterType, startDate, endDate, dispatch, getDateRange]);

    const onFilterhandler = useCallback((val) => {
        const dateRange = getDateRange();
        if (!dateRange) return;

        setType(val);
        dispatch(globalLoadingAction(true));
        dispatch(getOwnReportLeaveListData(userId, filterType, dateRange.start, dateRange.end, val));
    }, [userId, filterType, getDateRange, dispatch]);

    const onSubmitLeaveHandler = () => {
        let error = false;
        const errorObj = { ...errorsLeaveObj };

        if (leaveStartDate === null) {
            errorObj.startDate = 'Date is Required';
            error = true;
        }
        if (leaveTypes === '') {
            errorObj.type = 'Leave type is Required';
            error = true;
        }
        if (leaveDescription === '') {
            errorObj.hours = 'Hours is required';
            error = true;
        } else if (!/^\d+(\.\d+)?$/.test(leaveDescription)) {
            errorObj.hours = 'Only numbers are allowed (e.g., 2 or 2.5)';
            error = true;
        }

        setLeaveErrors(errorObj);
        if (error) {
            return;
        }
        dispatch(globalLoadingAction(true));
        dispatch(AddReportPersonalDetailsData(leaveTypes, leaveStartDate ? moment(leaveStartDate).format("YYYY-MM-DD") : '', Number(leaveDescription), ListCallBack));
    }

    const ListCallBack = () => {
        onFilterhandler(type);
        generateReport();
        onSetIsLeave();
    }
    const onSetIsLeave = () => {
        setIsLeave(!isLeave);
        closeLeave();
    }
    const closeLeave = () => {
        setLeaveErrors(errorsLeaveObj);
        setLeaveDescription('');
        setLeaveStartDate(null);
        setLeaveTypes('')
    }

    const onHoursHandler = (val) => {
        setLeaveDescription(val);
    }

    const onEditHandler = (index, isval) => {
        setIsIndex(index);
        setIsEdit(isval);
    }
    const onChangeHandler = (val, parentIndex, childIndex) => {
        const updatedList = [...list];

        // Allow numbers with up to 2 decimal places
        const isDecimal = /^\d*\.?\d{0,2}$/.test(val);
        if (!isDecimal && val !== '') return;

        // Keep raw string value to allow live editing (e.g., typing "0.")
        const updatedValues = [...updatedList[parentIndex].values];
        updatedValues[childIndex] = val;

        // Calculate total with parsed numbers only
        const total = updatedValues.reduce((sum, v) => {
            const parsed = parseFloat(v);
            return sum + (isNaN(parsed) ? 0 : parsed);
        }, 0);

        updatedList[parentIndex] = {
            ...updatedList[parentIndex],
            values: updatedValues,
            total: total
        };
        setList(updatedList);
        const totalHours = updatedList.reduce((acc, curr) => acc + (curr.total || 0), 0);
        setTotal(totalHours);
        const grand = parseFloat(grandHour);
        setGrandTotal(!isNaN(totalHours) && !isNaN(grand) ? totalHours + grand : 0);
        let obj = { headers: personalDetails?.headers, data: updatedList }
        changeReport(obj);
    };



    return (
        <Fragment>
            <div className="leave-cart-container">
                <div className="leave-cart-container-lft">
                    <h3>Personal Details
                        {/* {isAddLeave && (
                            <button className="personal-details-btn" onClick={() => onSetIsLeave()}>{" "}{isLeave ? <i class="fa fa-minus"></i> : <i class="fa fa-plus"></i>}</button>)} */}
                        {!isAddLeave && (
                            <button className="personal-details-btn" onClick={() => setIsCollapse(!isCollapse)}>{" "}{isCollapse ? <i class="fa fa-angle-up"></i> : <i class="fa fa-angle-down"></i>}</button>)}
                    </h3>
                </div>
                <div className="leave-cart-container-rght">
                    <div className="form-group card-filter-select">
                        <div className="select-drop-down">
                            <span><i class="fa fa-angle-down"></i></span>
                            <select
                                defaultValue={"option"}
                                className="form-control select-control"
                                value={type}
                                onChange={(e) => onFilterhandler(e.target.value)}>
                                <option value="">All</option>
                                {
                                    leaveType.map((item, index) => {
                                        return <option key={index} value={item._id}>{item.title}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    {isAddLeave && (
                        <div className="add-leave-container">
                            <button onClick={() => onSetIsLeave()}>{isLeave ? <i class="fa fa-minus"></i> : <i class="fa fa-plus"></i>}</button>
                        </div>)}
                </div>
            </div>
            {isCollapse && (
                <>
                    {isLeave && isAddLeave ?
                        <div className="inline-leave-view">
                            <div className="row inline-leave-row">
                                <div className="form-group form-group-modal-custom col-4">
                                    <div className="form-calendar">
                                        <DatePicker
                                            ref={leaveStartDateRef}
                                            selected={leaveStartDate}
                                            className="form-control"
                                            placeholderText="Select Date"
                                            onChange={(date) => setLeaveStartDate(date)}
                                        />
                                        <button type='button' className="form-calendar-btn"
                                            onClick={() => leaveStartDateRef.current.setOpen(true)}
                                        >
                                            <i class="fa-regular fa-calendar-days"></i>
                                        </button>
                                    </div>
                                    {leaveErrors.startDate && <div className="text-danger fs-12">{leaveErrors.startDate}</div>}
                                </div>

                                <div className="form-group form-group-modal-custom col-4">
                                    <div className="select-drop-down">
                                        <span><i class="fa fa-angle-down"></i></span>
                                        <select
                                            class="form-control select-control"
                                            value={leaveTypes}
                                            onChange={(e) => setLeaveTypes(e.target.value)}>
                                            <option value=''>Select Leave type</option>
                                            {
                                                leaveType.map((item, index) => {
                                                    return <option key={index} value={item._id}>{item.title}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    {leaveErrors.type && <div className="text-danger fs-12">{leaveErrors.type}</div>}
                                </div>
                                <div className="form-group form-group-modal-custom col-4">
                                    <input className="form-control" placeholder="Enter hours" value={leaveDescription} onChange={(e) => onHoursHandler(e.target.value)} />
                                    {leaveErrors.hours && <div className="text-danger fs-12">{leaveErrors.hours}</div>}
                                </div>
                            </div>
                            <div>
                                <button type='button' className="leave-submit-btn" onClick={() => onSubmitLeaveHandler()}>Submit</button>
                            </div>
                        </div> : null}

                    <Table className="cart-table table-bordered leave-scroll-table">
                        <thead>
                            <tr className="cart-table-header">
                                <th className="leave-type-title"><strong>Leave Type</strong></th>
                                {personalDetails?.headers?.map((day, i) => (
                                    <th key={i}><strong>{day}</strong></th>
                                ))}
                                <th className="text-center"><strong>Total</strong></th>
                                {isEditLeave && (<th className="text-center"><strong>Action</strong></th>)}
                            </tr>
                        </thead>

                        <tbody>
                            {list?.length > 0 ? (
                                list.map((item, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td className="leave-type-title"><strong>{item.type}</strong></td>
                                        {item.values?.map((value, colIndex) => (
                                            isEdit && isIndex === rowIndex ? (
                                                <td key={colIndex}>
                                                    <input
                                                        className="timeEditable-control"
                                                        onChange={(e) => onChangeHandler(e.target.value, rowIndex, colIndex)}
                                                        value={
                                                            value === '' || value === null || value === undefined
                                                                ? ''
                                                                : typeof value === 'number'
                                                                    ? value.toFixed(2)
                                                                    : value
                                                        }
                                                    />

                                                </td>
                                            ) : (
                                                <td key={colIndex} style={{ fontWeight: value > 0 ? '600' : '100' }}>
                                                    {typeof value === 'number' ? value.toFixed(2) : value ?? '0.00'}
                                                </td>
                                            )
                                        ))}

                                        <td className="text-center"><strong>{typeof item.total === 'number' ? item.total.toFixed(2) : item.total ?? '-'}</strong></td>
                                        {isEditLeave && (
                                            <td className="text-center">
                                                {
                                                    isEdit && isIndex === rowIndex ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-warning btn-xs"
                                                            onClick={() => onEditHandler(rowIndex, false)}
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="btn btn-warning btn-xs"
                                                            onClick={() => onEditHandler(rowIndex, true)}
                                                        >
                                                            <i className="fas fa-pencil-alt"></i>
                                                        </button>
                                                    )
                                                }
                                            </td>)}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={(personalDetails?.headers?.length || 0) + 2} className="text-center">
                                        No leave data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <div className="personal-hours">
                        <label className="mt-2"><strong>Total personal hours : </strong>{total?.toFixed(2)}</label>
                        <label className="mt-2"><strong>Grand Total hours : </strong> {grandTotal.toFixed(2)}</label>
                    </div>
                </>)}
        </Fragment>
    );
};

export default LeaveCardView;
